/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Bank_Account_HolderInputs */

const en_clients_field_bank_account_holder = /** @type {(inputs: Clients_Field_Bank_Account_HolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Holder Name`)
};

const pt_br2_clients_field_bank_account_holder = /** @type {(inputs: Clients_Field_Bank_Account_HolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titular`)
};

/**
* | output |
* | --- |
* | "Holder Name" |
*
* @param {Clients_Field_Bank_Account_HolderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_bank_account_holder = /** @type {((inputs?: Clients_Field_Bank_Account_HolderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Bank_Account_HolderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_bank_account_holder(inputs)
	return pt_br2_clients_field_bank_account_holder(inputs)
});